export function parameterizeString (string) {
  return string.trim().toLowerCase().replace(/[^a-zA-Z\d -]/, '-').replace(/\s/g, '-')
}
